import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "no-mb"
}

import { computed } from 'vue'
import { issueStore } from '@/stores/issue'
import IssueShowComment from '@/views/issue/cards/IssueShowComment.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowCommentsCard',
  setup(__props) {

const comments = computed(() => {
  return issueStore().issue.comments
})

let sortOrder = 'asc'

function sortComments () : void {
  issueStore().issue.comments.reverse()
  sortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: 'Berichten (' + _unref(issueStore)().issue.comments.length + ')',
    bordered: false
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: sortComments }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(sortOrder) === 'asc' ? 'Oudste eerst' : 'Nieuwste eerst'), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_unref(issueStore)().issue.comments.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(comments), (comment) => {
            return (_openBlock(), _createBlock(IssueShowComment, {
              comment: comment,
              key: comment.id
            }, null, 8, ["comment"]))
          }), 128))
        : (_openBlock(), _createElementBlock("p", _hoisted_1, "Er zijn nog geen berichten."))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})